var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"fa-stack"},[_c('i',{class:['fas fa-circle fa-stack-2x', _vm.accountTypes[_vm.type].iconBackGroundColor]}),_c('i',{class:['fas', _vm.accountTypes[_vm.type].icon, 'fa-stack-1x fa-inverse text-white']})])
}
var staticRenderFns = []

export { render, staticRenderFns }